<template>
  <el-container class="productTask">
    <el-main style="padding: 0">
      <view-table
          ref="viewTable"
          :limits="limits"
          :columns-property="columnsProperty"
          :filter="filter"
          module="basic"
          url="productionManage/list"
          :table-footer-msg="tableFooterMsg"
          @select="selectHandle"
          @update="getTableFooterMsg">
        <template slot="otherBtn">
          <el-button
              style="float: left;margin-top: 5px;"
              :disabled="selection.length!==1||loadingPrintCode"
              type="primary"
              @click="printCode()">
            标签打印
          </el-button>
          <el-button
              style="float: left;margin-top: 5px;"
              :disabled="selection.length!==1||loadingPrintCode"
              type="primary"
              @click="printCodeV2()">
            标签打印V2
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              style="float: left;margin-top: 5px;"
              :disabled="selection.length!==1||loadingPrintCode"
              type="primary"
              @click="printCode1()">
            标签打印(Logo)
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              style="float: left;margin-top: 5px;"
              :disabled="selection.length!==1||loadingPrintCode"
              type="primary"
              @click="printCode2()">
            标签打印(无Logo)
          </el-button>
          <el-button
              style="float: left;margin-top: 5px;"
              :disabled="selection.length===0"
              type="primary"
              @click="printTask()">
            工单打印
          </el-button>
          <el-button
              style="float: left;margin-top: 5px;"
              :disabled="selection.length===0"
              type="primary"
              @click="printTaskWithSop()">
            工单打印(操作卡)
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              style="float: left;margin-top: 5px;"
              :disabled="selection.length!==1||loadingPrintBoxLabel"
              type="primary"
              @click="printBoxLabel()">
            箱标打印
          </el-button>
          <el-button
              v-if="limits.labelPrintAuth"
              style="float: left;margin-top: 5px;"
              :disabled="selection.length!==1"
              type="primary"
              @click="printLabel">
            打印装箱单
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              slot="append"
              style="margin-top: 5px;"
              :disabled="selection.length!==1"
              type="primary"
              @click="printLabel1">
            电阻内盒铭牌(80*40)
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              slot="append"
              style="margin-top: 5px;"
              :disabled="selection.length!==1"
              type="primary"
              @click="printLabel2">
            电阻内盒中性(80*40)
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              slot="append"
              style="margin-top: 5px;"
              :disabled="selection.length!==1"
              type="primary"
              @click="printLabel2a1">
            电阻产品标(35*16)
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              slot="append"
              style="margin-top: 5px;"
              :disabled="selection.length!==1"
              type="primary"
              @click="printLabel3">
            电阻箱产品标(80*40)
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              slot="append"
              style="margin-top: 5px;"
              :disabled="selection.length!==1"
              type="primary"
              @click="printLabel3a0">
            电阻箱产品标(60*30)
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              slot="append"
              style="margin-top: 5px;"
              :disabled="selection.length!==1"
              type="primary"
              @click="printLabel3a1">
            电阻箱产品标(50*25)
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              slot="append"
              style="margin-top: 5px;"
              :disabled="selection.length!==1"
              type="primary"
              @click="printLabel6">
            电抗(60*30)
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              slot="append"
              style="margin-top: 5px;"
              :disabled="selection.length!==1"
              type="primary"
              @click="printLabel6a1">
            电抗(50*25)
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              slot="append"
              style="margin-top: 5px;"
              :disabled="selection.length!==1"
              type="primary"
              @click="printLabel6a4">
            远景(50*25)
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              slot="append"
              style="margin-top: 5px;"
              :disabled="selection.length!==1"
              type="primary"
              @click="printLabel6a2">
            电抗(20*26)
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              slot="append"
              style="margin-top: 5px;"
              :disabled="selection.length!==1"
              type="primary"
              @click="printLabel6a3">
            ATR(60*30)
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              slot="append"
              style="margin-top: 5px;"
              :disabled="selection.length!==1"
              type="primary"
              @click="printLabel7">
            追溯码(25*11)
          </el-button>
          <el-button
              v-if="limits.nameplatePrintAuth"
              slot="append"
              style="margin-top: 5px;"
              :disabled="selection.length!==1"
              type="primary"
              @click="printLabel8">
            客户条码(36*15)
          </el-button>
        </template>
        <template slot="adSearch">
          <div class="vm-search">
            <el-form :inline="true" :model="filter" label-width="90px" @keyup.enter.native="loadData(1)">
              <el-form-item label="工单编号">
                <el-input v-model.trim="filter.productionOrderNo" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="派工单号">
                <el-input v-model.trim="filter.billNo" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="物料编号">
                <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="物料类型">
                <el-select
                    v-model="materialTypeList"
                    :popper-append-to-body="false"
                    class="biddingStageSty"
                    multiple
                    clearable
                    placeholder="请选择"
                    @change="handleSelectMaterialType">
                  <el-option
                      v-for="item in materialTypeOptions"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"/>
                </el-select>
              </el-form-item>
              <el-form-item label="物料名称">
                <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="规格型号">
                <el-input v-model.trim="filter.materialSpecification" placeholder="请输入" clearable/>
              </el-form-item>
              <!--              <el-form-item label="工作中心">-->
              <!--                <el-input v-model.trim="filter.workCenterName" placeholder="请选择工作中心" clearable>-->
              <!--                  <el-button slot="append" icon="el-icon-search" @click="$refs.workCenterSelect.open()"/>-->
              <!--                </el-input>-->
              <!--              </el-form-item>-->
              <el-form-item label="工单状态">
                <!--                <el-select v-model="filter.status" placeholder="请选择" clearable>-->
                <!--                  <el-option label="已排产" :value="20"/>-->
                <!--                  <el-option label="已开工" :value="30"/>-->
                <!--                  <el-option label="已完工" :value="80"/>-->
                <!--                  &lt;!&ndash;                <el-option label="已暂停" :value="40"/>&ndash;&gt;-->
                <!--                  <el-option label="已检验" :value="90"/>-->
                <!--                  <el-option label="已入库" :value="100"/>-->
                <!--                  <el-option label="已关闭" :value="999"/>-->
                <!--                </el-select>-->
                <el-select
                    v-model="biddingStage"
                    :popper-append-to-body="false"
                    class="biddingStageSty"
                    multiple
                    clearable
                    placeholder="请选择"
                    @change="handleSelect">
                  <el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.value"/>
                </el-select>
              </el-form-item>
              <el-form-item label="客户名称">
                <el-input v-model.trim="filter.customerName" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="最终客户">
                <el-input v-model.trim="filter.finalCustomerName" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="发料状态">
                <el-select v-model="filter.feedingStatus" placeholder="请选择" clearable>
                  <el-option label="全部" :value="0"/>
                  <el-option label="待发料" :value="10"/>
                  <el-option label="部分发料" :value="20"/>
                  <el-option label="已发料" :value="80"/>
                </el-select>
              </el-form-item>
              <el-form-item label="计划开工日期">
                <el-date-picker
                    v-model="planStartDateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('planStartDateRange', 'planStartFrom', 'planStartTo')"/>
              </el-form-item>
              <el-form-item label="计划完工日期">
                <el-date-picker
                    v-model="planFinishDateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('planFinishDateRange', 'planFinishFrom', 'planFinishTo')"/>
              </el-form-item>
              <el-form-item label="开工日期">
                <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('dateRange','startFrom','startTo')"/>
              </el-form-item>
              <el-form-item label="完工日期">
                <el-date-picker
                    v-model="finishDateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('finishDateRange','finishFrom','finishTo')"/>
              </el-form-item>
              <el-form-item label="检验日期">
                <el-date-picker
                    v-model="inspectionDateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('inspectionDateRange','inspectionStartTime','inspectionEndTime')"/>
              </el-form-item>
              <el-form-item label="入库日期">
                <el-date-picker
                    v-model="instockDateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('instockDateRange','instockStartTime','instockEndTime')"/>
              </el-form-item>
              <el-form-item label="交货日期">
                <el-date-picker
                    v-model="deliveryDateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('deliveryDateRange','soDeliveryStartDate','soDeliveryEndDate')"/>
              </el-form-item>
              <el-form-item label="销售单号">
                <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="合同号">
                <el-input v-model.trim="filter.customerContractNo" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="发货通知单">
                <el-select v-model="filter.deliveryStatus" placeholder="请选择" clearable>
                  <el-option label="未创建" :value="0"/>
                  <el-option label="已创建" :value="10"/>
                </el-select>
              </el-form-item>
              <el-form-item label="当前工序">
                <el-input v-model.trim="filter.currProcess" placeholder="请选择" clearable/>
              </el-form-item>
              <el-form-item label="工作中心">
                <el-input v-model="filter.workCenterNames" type="textarea" placeholder="请输入" clearable/>
              </el-form-item>
            </el-form>
          </div>
        </template>
        <template slot="actionBtn" slot-scope="scope">
          <!--          <el-button-->
          <!--              v-if="limits.startAuth"-->
          <!--              type="primary"-->
          <!--              :disabled="[30, 80,90,100].includes(scope.row.status) || scope.row.feedingStatus===10"-->
          <!--              @click="startWorking(scope.row)">-->
          <!--            开工-->
          <!--          </el-button>-->
          <!--          <el-button-->
          <!--              v-if="limits.finishAuth"-->
          <!--              type="danger"-->
          <!--              :disabled="scope.row.status !== 30 || scope.row.feedingStatus===10"-->
          <!--              @click="completeWorking(scope.row)">-->
          <!--            完工-->
          <!--          </el-button>-->
          <el-button v-if="limits.repairAuth" @click="repairProd(scope.row)">返修</el-button>

          <el-button
              v-if="limits.closeAuth"
              type="danger"
              :disabled="[10,20,100].includes(scope.row.status)"
              @click="closeWorking(scope.row)">
            关闭
          </el-button>
          <el-button type="primary" @click="updateDate(scope.row)">维护交期</el-button>
        </template>
      </view-table>
    </el-main>
    <material-code-modal ref="materialCodeModal"/>
    <material-code-modal1 ref="materialCodeModal1"/>
    <material-code-modal2 ref="materialCodeModal2"/>
    <material-code-modal3 ref="materialCodeModal3"/>
    <print-order-modal ref="printOrderModal"/>
    <print-order-modal-with-sop-list ref="printOrderWithSop"/>
    <print-production-card ref="printProductionCard"/>
    <print-production-card2 ref="printProductionCard2"/>
    <production-order-repair-time ref="orderRepairTime"/>
    <!-- 工作中心选择 -->
    <work-center-select ref="workCenterSelect" @select="workCenterSelect"/>
    <production-order-preview ref="detailPage"/>
    <delivery-notice-label ref="deliveryNoticeLabel"/>
    <material-stock-preview ref="stockPreview"/>
    <material-box-label-modal ref="boxLabel"/>
    <task-final-delivery ref="taskFinalDelivery" @save-success="loadData(1)"/>
    <!--    标签-->
    <label-modal1 ref="labelModal1"/>
    <label-modal2 ref="labelModal2"/>
    <label-modal2a1 ref="labelModal2a1"/>
    <label-modal3 ref="labelModal3"/>
    <label-modal3a0 ref="labelModal3a0"/>
    <label-modal3a1 ref="labelModal3a1"/>
    <label-modal6 ref="labelModal6"/>
    <label-modal6a1 ref="labelModal6a1"/>
    <label-modal6a2 ref="labelModal6a2"/>
    <label-modal6a3 ref="labelModal6a3"/>
    <label-modal6a4 ref="labelModal6a4"/>
    <label-modal7 ref="labelModal7"/>
    <label-modal8 ref="labelModal8"/>
  </el-container>
</template>
<script>
  import MaterialCodeModal from "../ProductionOrder/MaterialCodeModal";
  import MaterialCodeModal1 from "../ProductionOrder/MaterialCodeModal1";
  import MaterialCodeModal2 from "../ProductionOrder/MaterialCodeModal2";
  import MaterialCodeModal3 from "../ProductionOrder/MaterialCodeModal3";
  import PrintOrderModal from "../ProductionOrder/PrintOrderModalList";
  import PrintProductionCard from "../ProductionOrder/PrintProductionCard";
  import PrintProductionCard2 from "../ProductionOrder/PrintProductionCard2";
  import WorkCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
  import ProductionOrderPreview from "../ProductionOrder/ProductionOrderPreview.vue";
  import ProductionOrderRepairTime from "@/views/ProductionManagement/ProductionTask/ProductionOrderRepairTime";
  import ViewTable from "@/components/ViewTable";
  import DeliveryNoticeLabel from "@/views/StoreManagement/OutStockDelivery/DeliveryNoticeLabel";
  import MaterialStockPreview from "@/views/ProductionManagement/ProductionProject/MaterialStockPreview";
  import PrintOrderModalWithSopList from "@/views/ProductionManagement/ProductionOrder/PrintOrderModalWithSopList";
  import MaterialBoxLabelModal from "@/views/ProductionManagement/ProductionTask/MaterialBoxLabelModal";
  import TaskFinalDelivery from "@/views/ProductionManagement/ProductionTask/TaskFinalDelivery";
  import LabelModal1 from "@/views/ProductionManagement/ProductionTask/LabelModal1";
  import LabelModal2 from "@/views/ProductionManagement/ProductionTask/LabelModal2";
  import LabelModal2a1 from "@/views/ProductionManagement/ProductionTask/LabelModal2a1";
  import LabelModal3 from "@/views/ProductionManagement/ProductionTask/LabelModal3";
  import LabelModal3a0 from "@/views/ProductionManagement/ProductionTask/LabelModal3a0";
  import LabelModal3a1 from "@/views/ProductionManagement/ProductionTask/LabelModal3a1";
  import LabelModal6 from "@/views/ProductionManagement/ProductionTask/LabelModal6";
  import LabelModal6a1 from "@/views/ProductionManagement/ProductionTask/LabelModal6a1";
  import LabelModal6a2 from "@/views/ProductionManagement/ProductionTask/LabelModal6a2";
  import LabelModal6a3 from "@/views/ProductionManagement/ProductionTask/LabelModal6a3";
  import LabelModal6a4 from "@/views/ProductionManagement/ProductionTask/LabelModal6a4";
  import LabelModal7 from "@/views/ProductionManagement/ProductionTask/LabelModal7";
  import LabelModal8 from "@/views/ProductionManagement/ProductionTask/LabelModal8";


  export default {
    name: "ProductionTaskList",
    components: {
      ViewTable,
      MaterialCodeModal,
      MaterialCodeModal1,
      MaterialCodeModal2,
      MaterialCodeModal3,
      WorkCenterSelect,
      PrintOrderModal,
      PrintOrderModalWithSopList,
      PrintProductionCard,
      PrintProductionCard2,
      ProductionOrderPreview,
      ProductionOrderRepairTime,
      DeliveryNoticeLabel,
      MaterialStockPreview,
      MaterialBoxLabelModal,
      TaskFinalDelivery,
      LabelModal1,
      LabelModal2,
      LabelModal2a1,
      LabelModal3,
      LabelModal3a0,
      LabelModal3a1,
      LabelModal6,
      LabelModal6a1,
      LabelModal6a2,
      LabelModal6a3,
      LabelModal6a4,
      LabelModal7,
      LabelModal8,
    },
    data() {
      return {
        limits: {
          startAuth: this.$auth(362),
          finishAuth: this.$auth(396),
          repairAuth: this.$auth(428),
          nameplatePrintAuth: this.$auth(389),
          labelPrintAuth: this.$auth(405),
          closeAuth: this.$auth(463),
        },
        labelId: "内盒铭牌",
        loadingPrintCode: false,
        loadingPrintBoxLabel: false,
        loadingLabelPrint1: false,
        loadingLabelPrint2: false,
        productionOrderId: "",
        currentRowIndex: "",
        workCenterList: [],
        selection: [],
        dateRange: [],
        planStartDateRange: [],
        planFinishDateRange: [],
        deliveryDateRange: [],
        inspectionDateRange: [],
        instockDateRange: [],
        materialTypeList: [],
        materialTypeOptions: [],
        productInfo: {
          feedingStatus: 10,
        },
        searchShow: false,
        finishDateRange: "",
        checkAll: false, //招标阶段 是否全选
        isIndeterminate: false, //全选复选框标识        
        options: [
          {name: "已排产", value: 20},
          {name: "已开工", value: 30},
          {name: "已完工", value: 80},
          {name: "已检验", value: 90},
          {name: "已入库", value: 100},
          {name: "已关闭", value: 999},
        ],
        biddingStage: [],
        filter: {
          productionOrderNo: "",
          billNo: "",
          materialNo: "",
          materialTypeId: "",
          materialTypeIds: "",
          materialName: "",
          materialSpecification: "",
          workCenterNames: "",
          status: "",
          statuses: "",
          customerName: "",
          finalCustomerName: "",
          startFrom: "",
          startTo: "",
          planStartFrom: "",
          planStartTo: "",
          planFinishFrom: "",
          planFinishTo: "",
          finishFrom: "",
          finishTo: "",
          inspectionStartTime: "",
          inspectionEndTime: "",
          instockStartTime: "",
          instockEndTime: "",
          soDeliveryStartDate: "",
          soDeliveryEndDate: "",
          salesOrderNo: "",
          customerContractNo: "",
          // isScheduled: "", // 只查询已开工、已排产的数据
          feedingStatus: "",
          deliveryStatus: "",
          currProcess: "",
          pageSize: 20,
        },
        columnsProperty: [
          {
            key: "billNo",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.$refs.detailPage.open(params.row);
                      },
                    },
                  },
                  params.row.billNo,
              );
            },
          },
          {
            title: "采购到料状态",
            key: "purchaseStatus",
            width: 100,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: params.row.purchaseStatus === "缺料" ? "red" : "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        if (params.row.purchaseStatus) {
                          this.$refs.stockPreview.open(params.row.productionOrderNo, true);
                        }
                      },
                    },
                  },
                  params.row.purchaseStatus,
              );
            },
          },
          {
            key: "action",
            align: "center",
            width: 210,
            slot: "action",
            fixed: "right",
          },
        ],
        tableFooterMsg: "",
      };
    },

    watch: {
      // // 监听工单状态：如果有值就查询对应状态的数据 如果每值只查询已开工、已排产的数据
      // "filter.status": {
      //   handler(val) {
      //     if (val) {
      //       this.filter.isScheduled = "";
      //     }
      //   },
      // },
      "filter.statuses": {
        handler(val) {
          if (val) {
            this.biddingStage = [];
            this.options.map(item => {
              val.split(",").forEach((s) => {
                if (parseInt(s) === parseInt(item.value)) {
                  this.biddingStage.push(item.value);
                }
              });
            });
          }
        },
      },
      "filter.planStartFrom": {
        handler(newVal) {
          if (newVal) {
            this.planStartDateRange = [];
            this.planStartDateRange.push(this.filter.planStartFrom);
            this.planStartDateRange.push(this.filter.planStartTo);
          }
        },
      },
      "filter.planFinishFrom": {
        handler(newVal) {
          if (newVal) {
            this.planFinishDateRange = [];
            this.planFinishDateRange.push(this.filter.planFinishFrom);
            this.planFinishDateRange.push(this.filter.planFinishTo);
          }
        },
      },
      "filter.startFrom": {
        handler(newVal) {
          if (newVal) {
            this.dateRange = [];
            this.dateRange.push(this.filter.startFrom);
            this.dateRange.push(this.filter.startTo);
          }
        },
      },
      "filter.finishFrom": {
        handler(newVal) {
          if (newVal) {
            this.finishDateRange = [];
            this.finishDateRange.push(this.filter.finishFrom);
            this.finishDateRange.push(this.filter.finishTo);
          }
        },
      },
      "filter.inspectionStartTime": {
        handler(newVal) {
          if (newVal) {
            this.inspectionDateRange = [];
            this.inspectionDateRange.push(this.filter.inspectionStartTime);
            this.inspectionDateRange.push(this.filter.inspectionEndTime);
          }
        },
      },
      "filter.instockStartTime": {
        handler(newVal) {
          if (newVal) {
            this.instockDateRange = [];
            this.instockDateRange.push(this.filter.instockStartTime);
            this.instockDateRange.push(this.filter.instockEndTime);
          }
        },
      },
      "filter.soDeliveryStartDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.soDeliveryStartDate);
            this.deliveryDateRange.push(this.filter.soDeliveryEndDate);
          }
        },
      },
      "filter.materialTypeIds": {
        handler(val) {
          if (val) {
            this.materialTypeList = [];
            this.materialTypeOptions.map(item => {
              val.split(",").forEach((s) => {
                if (parseInt(s) === parseInt(item.value)) {
                  this.materialTypeList.push(item.value);
                }
              });
            });
          }
        },
      },
    },

    mounted() {
      this.getMaterialTypeList();
      this.loadData(1);
    },
    methods: {
      // 查询
      // getList(pageNum) {
      //   this.$refs.vmTable.getList(pageNum);
      // },


      handleSelect(value) {
        if (value.length) {
          this.biddingStage = value;
          this.filter.statuses = value.join(",");
        } else {
          this.biddingStage = [];
          this.filter.statuses = "";
        }
      },

      printLabel() {
        const labelData = {
          customerNo: this.selection[0].customerOuterNo,
          billNo: this.selection[0].productionOrderNo,
          orderNo: this.selection[0].productionOrderNo,
          materialName: this.selection[0].materialName,
          quantity: this.selection[0].quantity,
          specification: this.selection[0].specification,
          amount: 1,
          note: this.selection[0].salesOrderMaterialNote,
          date: this.$moment().format("yyyy-MM-DD"),
          manufactor: "上海鸿康电器有限公司",
          telephone: "021-37701209",
          pkid: this.selection[0].pkid,
        };
        if (this.selection[0].finalCustomerOuterNo && (this.selection[0].customerOuterNo == "SH.615" || this.selection[0].customerOuterNo == "03.009")) {
          labelData.customerNo = this.selection[0].finalCustomerOuterNo;
        }
        this.$refs.deliveryNoticeLabel.open(labelData);
      },
      getMaterialTypeList() {
        this.materialTypeOptions = [];
        this.$http.get("basic", "materialTypes/getAllList").then((res) => {
          if (res.success) {
            res.data.forEach((item) => {
              let temp = {"name": item.materialTypeName, "value": item.pkid};
              this.materialTypeOptions.push(temp);
            });
          }
        });
      },
      handleSelectMaterialType(value) {
        if (value.length) {
          // this.materialTypeList = value;
          this.filter.materialTypeIds = value.join(",");
        } else {
          // this.materialTypeList = [];
          this.filter.materialTypeIds = "";
        }
      },
      getTableFooterMsg() {
        this.tableFooterMsg = "总数量:0";
        this.$http.get("basic", "taskDispatchBills/selectCount", this.filter).then((res) => {
          if (res.success) {
            this.tableFooterMsg = "总数量:" + res.data;
          }
        });
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
        this.getTableFooterMsg();
        this.selection = [];
      },
      // 选择工作中心
      workCenterSelect(row) {
        this.filter.workCenterName = row.workCenterName;
        this.loadData(1);
      },

      selectHandle(selection) {
        this.selection = selection;
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      handleClick() {
        this.dateRange = [];
        this.finishDateRange = [];
        this.deliveryDateRange = [];
        this.submitDateRange = [];
      },
      updateDate(row) {
        this.$refs.taskFinalDelivery.open(row);

      },

      //内盒铭牌打印 80*40
      printLabel1() {
        this.$refs.labelModal1.open(this.selection[0]);
      },
      //内盒中性打印 80*40
      printLabel2() {
        this.$refs.labelModal2.open(this.selection[0]);
      },
      //电阻箱产品标 35*16
      printLabel2a1() {
        this.$refs.labelModal2a1.open(this.selection[0]);
      },
      //电阻箱产品标 80*40
      printLabel3() {
        this.$refs.labelModal3.open(this.selection[0]);
      },
      //电阻箱产品标 60*30
      printLabel3a0() {
        this.$refs.labelModal3a0.open(this.selection[0]);
      },
      //电阻箱产品标 50*25
      printLabel3a1() {
        this.$refs.labelModal3a1.open(this.selection[0]);
      },
      //电抗 60*30
      printLabel6() {
        this.$refs.labelModal6.open(this.selection[0]);
      },
      //电抗 50*25
      printLabel6a1() {
        this.$refs.labelModal6a1.open(this.selection[0]);
      },
      //远景 50*25
      printLabel6a4() {
        // this.$http.get("basic", `taskDispatchBills/${this.selection[0].pkid}`).then((res) => {
        //   if (res.success) {
        //     if (res.data.yjPrintTimes) {
        //       this.$refs.labelModal6a4.open(this.selection[0], res.data.yjPrintTimes);
        //     } else {
        //       this.$refs.labelModal6a4.open(this.selection[0], 0);
        //     }
        //   }
        // });

        this.$http.get("basic", "taskDispatchBills/getPrintNo").then((res) => {
          if (res.success) {
            if (res.data) {
              this.$refs.labelModal6a4.open(this.selection[0], res.data);
            } else {
              this.$refs.labelModal6a4.open(this.selection[0], 0);
            }
          }
        });
      },
      //电抗 20*26
      printLabel6a2() {
        this.$refs.labelModal6a2.open(this.selection[0]);
      },
      //ATR 60*30
      printLabel6a3() {
        this.$refs.labelModal6a3.open(this.selection[0]);
      },
      //追溯码 25*11
      printLabel7() {
        this.$refs.labelModal7.open(this.selection[0]);
      },
      //客户条码 36*15
      printLabel8() {
        this.$refs.labelModal8.open(this.selection[0]);
      },
      // 打印标签
      printCode() {
        this.loadingPrintCode = true;
        this.$http.get("basic", `productionManage/printsn?id=${this.selection[0].pkid}`).then((resp) => {
          if (resp.success) {
            if (resp.data.length) {
              // this.$refs.printProductionCard2.open(resp.data,productInfo);
              this.$refs.materialCodeModal.open(resp.data, this.selection[0]);
              // if (!resp.data[0].prodType) {
              //   this.$refs.materialCodeModal.open(resp.data, productInfo);
              // } else {
              //   productInfo.createTime = resp.data[0].prodTime;
              //   productInfo.finishQuantity = resp.data[0].quantity;
              //   productInfo.batchRowNo = resp.data[0].batchRowNo;
              //   this.$refs.printProductionCard.open(resp.data,productInfo);
              // }
            }
          }
          this.loadingPrintCode = false;
        }).catch(() => {
          this.loadingPrintCode = false;
        });
      },
      // 打印标签V2
      printCodeV2() {
        this.loadingPrintCode = true;
        this.$http.get("basic", `productionManage/printsn?id=${this.selection[0].pkid}`).then((resp) => {
          if (resp.success) {
            if (resp.data.length) {
              this.$refs.materialCodeModal3.open(resp.data, this.selection[0]);
            }
          }
          this.loadingPrintCode = false;
        }).catch(() => {
          this.loadingPrintCode = false;
        });
      },
      // 打印标签
      printCode1() {
        this.loadingPrintCode = true;
        this.$http.get("basic", `productionManage/printsn?id=${this.selection[0].pkid}`).then((resp) => {
          if (resp.success) {
            if (resp.data.length) {
              this.$refs.materialCodeModal1.open(resp.data, this.selection[0]);
            }
          }
          this.loadingPrintCode = false;
        }).catch(() => {
          this.loadingPrintCode = false;
        });
      },
      // 打印标签
      printCode2() {
        this.loadingPrintCode = true;
        this.$http.get("basic", `productionManage/printsn?id=${this.selection[0].pkid}`).then((resp) => {
          if (resp.success) {
            if (resp.data.length) {
              this.$refs.materialCodeModal2.open(resp.data, this.selection[0]);
            }
          }
          this.loadingPrintCode = false;
        }).catch(() => {
          this.loadingPrintCode = false;
        });
      },
      // 打印箱标
      printBoxLabel() {
        // this.loadingPrintBoxLabel = true;
        this.$refs.boxLabel.open(this.selection[0]);
        // this.$http.get("basic", `productionManage/printsn?id=${this.selection[0].pkid}`).then((resp) => {
        //   if (resp.success) {
        //     if (resp.data.length) {
        //       this.$refs.materialCodeModal1.open(resp.data, this.selection[0]);
        //     }
        //   }
        //   this.loadingPrintBoxLabel = false;
        // }).catch(() => {
        //   this.loadingPrintBoxLabel = false;
        // });
      },
      //打印工单
      printTask() {
        this.$refs.printOrderModal.open(this.selection);
      },
      printTaskWithSop() {
        this.$refs.printOrderWithSop.open(this.selection);
      },
      // 开工
      startWorking(row) {
        this.$confirm("确定开工吗?", "提示", {type: "warning"}).then(() => {
          this.$http.get("basic", `productionManage/start?id=${row.pkid}`).then(() => {
            this.loadData(1);
            this.$message.success("操作成功");
          });
        });
      },

      // 暂停
      stopWorking(row) {
        this.$confirm("确定暂定吗?", "提示", {type: "warning"}).then(() => {
          this.$http.get("basic", `productionManage/pause?id=${row.pkid}`).then(() => {
            this.loadData(1);
            this.$message.success("操作成功");
          });
        });
      },

      // 完工
      completeWorking(row) {
        this.$confirm("确定完工吗?", "提示", {type: "warning"}).then(() => {
          this.$http.get("basic", `productionManage/finish?id=${row.pkid}`).then(() => {
            this.loadData(1);
            this.$message.success("操作成功");
          });
        });
      },

      //关闭
      closeWorking(row) {
        this.$confirm("确定关闭吗?", "提示", {type: "warning"}).then(() => {
          this.$http.get("basic", `productionManage/close?id=${row.pkid}`).then(() => {
            this.loadData(1);
            this.$message.success("操作成功");
          });
        });
      },

      //返修
      repairProd(row) {
        this.$refs.orderRepairTime.open(row);
        this.loadData(1);
      },

      rowClick(row) {
        const tableData = this.$refs.vmTable.tableData;
        tableData.forEach((item, index) => {
          if (item.pkid === row.pkid) {
            this.currentRowIndex = index;
            this.productInfo = row;
            this.productionOrderId = row.pkid;
          }
        });
      },

      selectedRow(row, index) {
        this.currentRowIndex = index;
        this.productInfo = row;
        this.productionOrderId = row.pkid;
      },

      setSelectedRow(val) {
        this.rowClick(val);
      },


    },
  };
</script>

<style>
.productTask .el-table__body-wrapper::-webkit-scrollbar {
  width: 16px !important;
  height: 16px !important;
  z-index: 99999;
}

.productTask .el-table__fixed-right-patch {
  width: 16px !important;
}

.productTask .el-table__fixed-right {
  right: 16px !important;
  bottom: 16px !important;
}

.productTask .el-table .el-table__cell {
  padding: 8px 0;
}

.biddingStageSty /deep/ .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  display: none;
}
</style>
